var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.113,
    viewBox: "0 0 15 15.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667",
    transform: "translate(4346 10103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658",
    transform: "translate(2091 -717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 15,
    height: 15,
    transform: "translate(-6437 -9386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659",
    transform: "translate(0.933 46.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy-4",
    d: "M14.693,14.316a6.087,6.087,0,0,0-6.346-5.79A6.087,6.087,0,0,0,2,14.316",
    transform: "translate(-4347.779 -10149.078)",
    fill: "none",
    stroke: "#14a4c2",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_404",
    "data-name": "Path 404",
    transform: "translate(-4344.007 -10149.5)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.434,0A4.464,4.464,0,1,1,0,4.464,4.449,4.449,0,0,1,4.434,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.434132099151611 0.7499961853027344 C 2.402692317962646 0.7499961853027344 0.7500019073486328 2.41593599319458 0.7500019073486328 4.463655948638916 C 0.7500019073486328 6.511375904083252 2.402692317962646 8.177315711975098 4.434132099151611 8.177315711975098 C 6.465572357177734 8.177315711975098 8.11826229095459 6.511375904083252 8.11826229095459 4.463655948638916 C 8.11826229095459 2.41593599319458 6.465572357177734 0.7499961853027344 4.434132099151611 0.7499961853027344 M 4.434132099151611 -3.814697265625e-06 C 6.883031845092773 -3.814697265625e-06 8.86826229095459 1.998445987701416 8.86826229095459 4.463655948638916 C 8.86826229095459 6.928865909576416 6.883031845092773 8.927315711975098 4.434132099151611 8.927315711975098 C 1.985231876373291 8.927315711975098 1.9073486328125e-06 6.928865909576416 1.9073486328125e-06 4.463655948638916 C 1.9073486328125e-06 1.998445987701416 1.985231876373291 -3.814697265625e-06 4.434132099151611 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#ffa539"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/User Profile.9f96d046ac0aaad7acdf7b2793c8e6a3.svg";
export { ForwardRef as ReactComponent };